/* dojo */
import accordionPane from './dojo/accordion.m.css';
import avatar from './dojo/avatar.m.css';
import breadcrumbGroup from './dojo/breadcrumb-group.m.css';
import button from './dojo/button.m.css';
import calendar from './dojo/calendar.m.css';
import card from './dojo/card.m.css';
import checkboxGroup from './dojo/checkbox-group.m.css';
import checkbox from './dojo/checkbox.m.css';
import chipTypeahead from './dojo/chip-typeahead.m.css';
import chip from './dojo/chip.m.css';
import dateInput from './dojo/date-input.m.css';
import dialog from './dojo/dialog.m.css';
import floatingActionButton from './dojo/floating-action-button.m.css';
import form from './dojo/form.m.css';
import gridBody from './dojo/grid-body.m.css';
import gridCell from './dojo/grid-cell.m.css';
import gridFooter from './dojo/grid-footer.m.css';
import gridHeader from './dojo/grid-header.m.css';
import gridPaginatedFooter from './dojo/grid-paginated-footer.m.css';
import gridPlaceholderRow from './dojo/grid-placeholder-row.m.css';
import gridRow from './dojo/grid-row.m.css';
import grid from './dojo/grid.m.css';
import headerCard from './dojo/header-card.m.css';
import header from './dojo/header.m.css';
import helperText from './dojo/helper-text.m.css';
import icon from './dojo/icon.m.css';
import label from './dojo/label.m.css';
import listItem from './dojo/list-item.m.css';
import list from './dojo/list.m.css';
import loadingIndicator from './dojo/loading-indicator.m.css';
import menuItem from './dojo/menu-item.m.css';
import nativeSelect from './dojo/native-select.m.css';
import pagination from './dojo/pagination.m.css';
import passwordInput from './dojo/password-input.m.css';
import popupConfirmation from './dojo/popup-confirmation.m.css';
import popup from './dojo/popup.m.css';
import progress from './dojo/progress.m.css';
import radioGroup from './dojo/radio-group.m.css';
import radio from './dojo/radio.m.css';
import rangeSlider from './dojo/range-slider.m.css';
import rate from './dojo/rate.m.css';
import result from './dojo/result.m.css';
import select from './dojo/select.m.css';
import slidePane from './dojo/slide-pane.m.css';
import slider from './dojo/slider.m.css';
import snackbar from './dojo/snackbar.m.css';
import speedDial from './dojo/speed-dial.m.css';
import switchControl from './dojo/switch.m.css';
import tabContainer from './dojo/tab-container.m.css';
import textArea from './dojo/text-area.m.css';
import textInput from './dojo/text-input.m.css';
import threeColumnLayout from './dojo/three-column-layout.m.css';
import timePicker from './dojo/time-picker.m.css';
import titlePane from './dojo/title-pane.m.css';
import tooltip from './dojo/tooltip.m.css';
import twoColumnLayout from './dojo/two-column-layout.m.css';
import tree from './dojo/tree.m.css';
import typeahead from './dojo/typeahead.m.css';
import wizard from './dojo/wizard.m.css';
// dojo theme variants
import darkVariant from './dojo/variants/dark.m.css';
import defaultVariant from './dojo/variants/default.m.css';

export default {
	theme: {
		// @dojo widgets
		'@dojo/widgets/accordion': accordionPane,
		'@dojo/widgets/avatar': avatar,
		'@dojo/widgets/breadcrumb-group': breadcrumbGroup,
		'@dojo/widgets/button': button,
		'@dojo/widgets/calendar': calendar,
		'@dojo/widgets/card': card,
		'@dojo/widgets/checkbox-group': checkboxGroup,
		'@dojo/widgets/checkbox': checkbox,
		'@dojo/widgets/chip-typeahead': chipTypeahead,
		'@dojo/widgets/chip': chip,
		'@dojo/widgets/date-input': dateInput,
		'@dojo/widgets/dialog': dialog,
		'@dojo/widgets/floating-action-button': floatingActionButton,
		'@dojo/widgets/form': form,
		'@dojo/widgets/grid-body': gridBody,
		'@dojo/widgets/grid-cell': gridCell,
		'@dojo/widgets/grid-footer': gridFooter,
		'@dojo/widgets/grid-header': gridHeader,
		'@dojo/widgets/grid-placeholder-row': gridPlaceholderRow,
		'@dojo/widgets/grid-paginated-footer': gridPaginatedFooter,
		'@dojo/widgets/grid-row': gridRow,
		'@dojo/widgets/grid': grid,
		'@dojo/widgets/header-card': headerCard,
		'@dojo/widgets/header': header,
		'@dojo/widgets/helper-text': helperText,
		'@dojo/widgets/icon': icon,
		'@dojo/widgets/label': label,
		'@dojo/widgets/list-item': listItem,
		'@dojo/widgets/loading-indicator': loadingIndicator,
		'@dojo/widgets/menu-item': menuItem,
		'@dojo/widgets/list': list,
		'@dojo/widgets/native-select': nativeSelect,
		'@dojo/widgets/pagination': pagination,
		'@dojo/widgets/password-input': passwordInput,
		'@dojo/widgets/popupConfirmation': popupConfirmation,
		'@dojo/widgets/popup': popup,
		'@dojo/widgets/progress': progress,
		'@dojo/widgets/radio-group': radioGroup,
		'@dojo/widgets/radio': radio,
		'@dojo/widgets/range-slider': rangeSlider,
		'@dojo/widgets/rate': rate,
		'@dojo/widgets/result': result,
		'@dojo/widgets/select': select,
		'@dojo/widgets/slide-pane': slidePane,
		'@dojo/widgets/slider': slider,
		'@dojo/widgets/snackbar': snackbar,
		'@dojo/widgets/speed-dial': speedDial,
		'@dojo/widgets/switch': switchControl,
		'@dojo/widgets/tab-container': tabContainer,
		'@dojo/widgets/text-area': textArea,
		'@dojo/widgets/text-input': textInput,
		'@dojo/widgets/three-column-layout': threeColumnLayout,
		'@dojo/widgets/time-picker': timePicker,
		'@dojo/widgets/title-pane': titlePane,
		'@dojo/widgets/tooltip': tooltip,
		'@dojo/widgets/two-column-layout': twoColumnLayout,
		'@dojo/widgets/tree': tree,
		'@dojo/widgets/typeahead': typeahead,
		'@dojo/widgets/wizard': wizard
	},
	variants: {
		default: defaultVariant,
		dark: darkVariant
	}
};
